(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
  const stickyBar = document.getElementById("sticky-add-to-cart");
  const productForm = document.querySelector("form[action*='/cart/add']");

  // scroll detection
  window.addEventListener("scroll", function() {
    let scrollPos = window.scrollY + window.innerHeight;
    let triggerPos = document.body.scrollHeight - 600; // footer से थोड़ा ऊपर
    
    if (scrollPos >= triggerPos) {
      stickyBar.style.display = "block";
    } else {
      stickyBar.style.display = "none";
    }
  });

  // Add to cart functionality
  document.querySelector("#sticky-add-to-cart .add-to-cart").addEventListener("click", function() {
    let qty = document.querySelector("#sticky-add-to-cart input[name='quantity']").value;
    let variantId = this.dataset.variant;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(res => res.json())
    .then(data => {
      alert("Added to cart!");
    })
    .catch(err => console.error(err));
  });
});
  } catch(e) { console.error(e); }
})();

})();
